
import React from 'react';
import Iframe from 'react-iframe'
const Map = () => {
    
      return (
      <div>
        <Iframe url="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d774.397657861498!2d89.35327976195458!3d24.832140495731327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x39fc545d82a5fabf%3A0xa9ecd854a9dea840!2sSilimpur%2C%20Bogura!3m2!1d24.832295799999997!2d89.3534092!5e1!3m2!1sen!2sbd!4v1656576946410!5m2!1sen!2sbd" 
       className="w-full h-96 rounded-lg " allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></Iframe>
       </div>
      )
    
};

export default Map;